import { useHookstate } from "@hookstate/core";
import { FB_GLOBAL_STATES, SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const useFoodOrdersCount = (siteSettingsData) => {
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { foodOrdersCourseFilter } =
    useHookstate(FB_GLOBAL_STATES);
  const { getFoodOrdersTabDataState } =
    useSelector((state) => state.commonReducers) || [];
  const [foodOrdersCourses, setFoodOrdersCourses] = useState([]);

  useEffect(() => {
    startGettingFoodOrders();
  }, [siteId.get(), siteSettingsData, getFoodOrdersTabDataState]);

  useEffect(() => {
    pendingFoodOrdersCount();
  }, [
    getFoodOrdersTabDataState,
    siteId.get(),
    foodOrdersCourses,
    pendingFoodOrdersCount(),
  ]);

  function startGettingFoodOrders() {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      let tempData = [];

      siteSettingsData?.Courses.forEach(function (course) {
        // if we have saved away an active setting for this course use it.
        let isActiveCourse = true;
        if (foodOrdersCourseFilter.get().courseFilters) {
          isActiveCourse = _.result(
            _.find(foodOrdersCourseFilter.get().courseFilters, {
              number: course?.Number,
            }),
            "active",
            true
          );
        }

        // Set up the initial values for which courses orders will be shown
        let viewCourseActive = {
          number: course?.Number,
          name: course?.Name,
          active: isActiveCourse,
        };
        tempData.push(viewCourseActive);
      });

      setFoodOrdersCourses(tempData);
    }
  }

  function pendingFoodOrdersCount() {
    return getFoodOrdersTabDataState &&
      getFoodOrdersTabDataState.length !== 0 &&
      foodOrdersCourses &&
      foodOrdersCourses.length !== 0
      ? getFoodOrdersTabDataState?.filter((order) => {
          let isActiveCourse = _.find(foodOrdersCourses, {
            number: order?.Course,
          })?.active;
          return !order.FulfilledDate && isActiveCourse;
        }).length
      : 0;
  }
  return {
    pendingFoodOrderCountVal: pendingFoodOrdersCount(),
  };
};
